module.exports = __webpack_public_path__ + "static/img/2219_phase_function_Paper_PointsHejduk_Prediction.78f277a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2219_phase_function_Paper_PointsHejduk_Prediction.png
// module id = S2UW
// module chunks = 0